import classNames from 'classnames';
import { ClassNameType } from 'interfaces';

const styles = {
  component: (className: ClassNameType) => {
    const defaultClasses = classNames(
      'relative',
    );

    return classNames(
      defaultClasses,
      className,
    );
  },
  range: classNames(
    'appearance-none',
    'bg-transparent',
    'cursor-pointer',
    'w-full',
    'relative',
    'z-20',
  ),
  label: classNames(
    'flex',
    'justify-between',
    'bg-darkGray-300',
    'h-1',
    'w-full',
    'absolute',
    'top-[10px]',
    'z-10',
  ),
  dots: (isActive: boolean = false) => classNames(
    'w-2',
    'h-2',
    'rounded-full',
    '-mt-[2px]',
    'block',
    {
      'bg-darkGray-300': !isActive,
      'bg-secondaryBlue': isActive,
    },
  ),
  values: classNames(
    'flex',
    'justify-between',
    'pl-1.5',
    '-mt-1.5',
  ),
  value: classNames(
    'text-darkGray-300',
    'text-sm',
  ),
};

export default styles;
